module.exports = __webpack_public_path__ + "3e01364b81af554c6b113dd3347fa265.pdf";